/**
 * 上传调度程序, 保证同时只能有一个文件在上传
 */
import { mockUploader } from "./common";
import { EventEmitter } from "eventemitter3";

export type Uploader = (
    file: File,
    onProgress: (percent: number) => void
) => Promise<string>;

interface Options {
    uploader: Uploader;
}

const OptionsDefault: Options = {
    uploader: mockUploader
};

export class UploadManager {
    private files: File[] = [];
    private options: Options;
    private event = new EventEmitter();
    private uploading = false;

    constructor(options?: Partial<Options>) {
        this.options = { ...OptionsDefault, ...options };
    }

    upload(file: File, onProgress: (percent: number) => void): Promise<string> {
        this.files.push(file);

        const promise = new Promise<string>((resolve, reject) => {
            const uploadStartListener = async (evt: any) => {
                if (evt.file !== file) return;

                try {
                    this.uploading = true;
                    const url = await this.options.uploader(file, onProgress);
                    resolve(url);
                } catch (e) {
                    reject(e);
                } finally {
                    this.uploading = false;
                    this.event.off("uploadStart", uploadStartListener);
                    this.remove(file);
                    this.next();
                }
            };

            this.event.on("uploadStart", uploadStartListener);
        });

        if (!this.uploading) this.next();
        return promise;
    }

    private next() {
        if (this.uploading) return;
        if (this.files.length === 0) return;
        this.event.emit("uploadStart", { file: this.files[0] });
    }

    private remove(file: File) {
        const index = this.files.findIndex(item => item === file);

        this.files.splice(index, 1);
    }
}
